import { Input } from '@iwoca/orion';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { TFormValues } from '../StripeLinkDebitCardForm';

export function BillingPostcodeField({
    formRegister,
    error
}: {
    formRegister: UseFormRegister<TFormValues>;
    error?: FieldError;
}) {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.billing_postcode_required',
        defaultMessage: 'Billing postcode is required'
    });

    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.billing_postcode"
                    defaultMessage="Billing postcode"
                />
            }
            htmlFor="billingPostcode"
            error={error ? errorMessage : null}
        >
            <Input
                type="text"
                id="billingPostcode"
                placeholder="e.g. N6 6NG"
                className="fs-exclude"
                {...formRegister('billingPostcode', { required: true })}
            />
        </DebitCardFieldWrapper>
    );
}
